import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '../../../core/services/notification.service';
import { SelectOption } from '../../models/select-option.type';
import { LaborService } from 'src/app/labor/labor.service';

@Component({
  selector: 'app-dialog-sms-worker',
  templateUrl: './dialog-sms-worker.component.html'
})
export class DialogSmsWorkerComponent implements OnInit {

  smsForm: FormGroup;
  loading: boolean;

  constructor(
    public fb: FormBuilder,
		private dialogRef: MatDialogRef<DialogSmsWorkerComponent>,
    private laborService: LaborService,
		private notificationService: NotificationService,
		@Inject(MAT_DIALOG_DATA) public data: {
			workerName: string;
      workerId: number;
      unionId: number;
			unionOptions: SelectOption[];
		}
  ) {}

	ngOnInit(): void {
		this.createForm();
	}

	private createForm(): void {
    const unionId: number = 
      this.data.unionId ? 
        this.data.unionId : 
        this.data.unionOptions?.length === 1 ? 
          this.data.unionOptions[0].value : 
          null;

		this.smsForm = this.fb.group({
			unionId: [unionId, Validators.required],
			comments: ['', Validators.required]
		});
	}

	confirm(): void {
    this.loading = true;
		this.laborService.sendTextToWorker(
			this.data.workerId,
			this.smsForm.get('comments').value,
			this.smsForm.get('unionId').value,
		).toPromise().then(
			(response) => {
        this.notificationService.showSuccess("The message was successfully sent");
				this.dialogRef.close(response);
			},
			(error) => {
        this.notificationService.showError("There was a problem sending the message. Please try again.");
        this.loading = false;
			}
		)
	}

	close(): void {
		this.dialogRef.close();
	}
}
